/**
 * @generated SignedSource<<21d4e958c59832aa544cb53e16441030>>
 * @relayHash d34404ea0f67a7a51972f5eff2c30868
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a8bf3dcd28ad0cdb3103facc55cfc33e1ff1cbe25d41b9ceb8b0600065afba06

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { VirtualAgentViewStandardFlowQuery } from './VirtualAgentViewStandardFlowQuery.graphql';

import checkForAiEnabledFF_provider from '@atlassian/jira-relay-provider/src/jsm-va-is-require-ai-enabled.relayprovider';

const node: PreloadableConcreteRequest<VirtualAgentViewStandardFlowQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a8bf3dcd28ad0cdb3103facc55cfc33e1ff1cbe25d41b9ceb8b0600065afba06",
    "metadata": {},
    "name": "VirtualAgentViewStandardFlowQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": checkForAiEnabledFF_provider
    }
  }
};

export default node;
